// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"961348aa","253":"9a57270e","304":"f0ec0928","453":"03346f77","476":"2692d72e","839":"a3bcbafd","863":"381307e2","889":"9f9eb914"}[chunkId] + ".chunk.js";
};